import { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from 'presentation/components/icons/IconContainer';
import overrideStyles from 'lib/overrideStyle';

import styles from 'presentation/components/styles/SubmitButton.css';

export default function SubmitButton(props) {
  SubmitButton.propTypes = {
    canAddAttachments: PropTypes.bool,
    hasContent: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };

  return (
    <OuterWrapper
      canAddAttachments={props.canAddAttachments}
      hasContent={props.hasContent}
      tabIndex="0"
      role="button"
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      data-aid="gladlyChatCompositionSubmit"
    >
      <InnerWrapper tabIndex="-1">
        <IconContainer
          className={styles.submitButtonIcon}
          viewBox="0 0 25 21"
          title={props.title}
          titleId="submitButtonTitleId"
        >
          <g fill="none" fillRule="evenodd">
            <path d="M1.577 10.5h21.377" strokeLinecap="square" />
            <path d="M13.4 1l9.6 9.435-9.667 9.5" />
          </g>
        </IconContainer>
      </InnerWrapper>
    </OuterWrapper>
  );
}

const InnerWrapper = overrideStyles('div')`
  outline: none;
`;

const slideIn = keyframes`
from {
  transform: translateX(30px);
  opacity: 0;
}

to {
  transform: initial;
  opacity: 1;
}
`;

const OuterWrapper = overrideStyles('div')`
  animation: ${slideIn} .5s ease-out;
  bottom: 15px;
  cursor: pointer;
  flex: 0 0 22px;
  height: 19px;
  margin: 0px 17px 7px 5px;
  padding: 2px 2px 1px 2px;
  position: absolute;
  right 2px;
  stroke: ${p => (p.hasContent ? p.theme.colors.submitArrow || p.theme.colors.brandPrimary : '#aaa')};
  strokeWidth: 1;
  width: 22px;
`;
